import React from 'react'
import { useNavigate } from 'react-router-dom'
import HomeConfigForm from '../components/home/HomeConfigForm'
import { HomeConfigFormData } from '../types/home'

const Sections: React.FC = () => {
  const navigate = useNavigate()

  const handleSave = (data: HomeConfigFormData) => {
    console.log('Home config saved:', data)
    // Hiển thị alert
    alert('Đã cập nhật cấu hình trang chủ thành công!')
    // Chuyển về trang chủ sau khi lưu thành công
    // navigate('/')
  }

  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-semibold text-gray-900">Quản lý trang chủ</h1>
      <HomeConfigForm onSave={handleSave} />
    </div>
  )
}

export default Sections 